import { useMutation } from "@tanstack/react-query";

import { axiosInstance } from "../../lib/axios";

import type { AxiosProgressEvent } from "axios";

export const useUploadFile = () => {
  return useMutation({
    mutationFn: uploadFunction,
  });
};

const uploadFunction = ({
  uploadUrl,
  file,
  headers = {},
  metadataFields = {},
  signal,
  onUploadProgress,
}: PayloadData) => {
  const method =
    import.meta.env.VITE_CLOUD_PROVIDER === "azure" ? "PUT" : "POST";

  let requestBody;
  if (import.meta.env.VITE_CLOUD_PROVIDER === "azure") {
    requestBody = file;
  } else {
    const formData = new FormData();
    Object.entries(metadataFields).forEach(([key, value]) => {
      formData.append(key, value as string);
    });
    formData.append("file", file);
    requestBody = formData;
  }

  return axiosInstance.request({
    url: uploadUrl,
    method,
    data: requestBody,
    headers: {
      ...headers,
      "Content-Type": file.type,
    },
    signal,
    onUploadProgress,
  });
};

type PayloadData = {
  uploadUrl: string;
  file: File;
  metadataFields: Record<string, unknown>;
  headers?: Record<string, string>;
  signal?: AbortSignal;
  onUploadProgress?: (progressEvent: AxiosProgressEvent) => void;
};
